import { usePocMutation } from 'core/custom-hooks/use-poc-mutation.hook';
import { DEVICE_TYPE_SOURCE } from 'core/contexts/device-types';
import { deviceKeys } from 'core/query-client/keys/device.keys';
import { updateQuery } from 'core/query-client/query-client';
import { executeRequest } from 'core/utils/backend-service';
import { DeviceTypeDetails } from 'modules/devices/domain/api/device-type.api';
import { updateDeviceTypeAOM } from './device-types.service';

interface UseUpdateDeviceTypeResult {
    updateDeviceType: (deviceType: DeviceTypeDetails) => Promise<{ result: string }>;
    isLoading: boolean;
}

export const useUpdateDeviceType = (): UseUpdateDeviceTypeResult => {
    const { mutateAsync, isPending: isLoading } = usePocMutation({
        mutationFn: (deviceType: DeviceTypeDetails) =>
            executeRequest<{ result: string }>(() => updateDeviceTypeAOM(deviceType)),
        onSuccess: () => updateQuery(deviceKeys.types(DEVICE_TYPE_SOURCE.AOM)),
    });

    return { updateDeviceType: mutateAsync, isLoading };
};
